const debug = import.meta.env.MODE !== 'production';

export const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE_URL || '';
};

export const getApiBaseUrlA = (): string => {
  return import.meta.env.VITE_API_BASE_URL_A || '';
};

export default debug;
